

module.exports = (rgb) => (0x1000000 + rgb.red * 0x10000 + rgb.green * 0x100 + rgb.blue).toString(16).toUpperCase().slice(1);



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/rgb/toHex.js